import i from 'i18next'

import ThumbVideoZoomable from '~/components/ThumbVideoZoomable'
import ThumbZoomable from '~/components/ThumbZoomable'

import HeaderAd from '../elements/HeaderAd'
import { getCampaignUrl } from '../../helpers'

export const BannerAds = ({ ads }: { ads: BannerAd[] }) =>
  ads.map(ad => (
    <article key={ad.ad_id} className="mb-2">
      <HeaderAd
        campaignURL={getCampaignUrl(ad.click_url)}
        campaignName={ad.campaign_name}
      />

      <section className="border rounded p-2">
        {ad.asset_type === 'video' ? (
          <ThumbVideoZoomable
            url={ad.media_url}
            title={ad.campaign_name}
            size="tiny"
          />
        ) : (
          <ThumbZoomable
            url={ad.media_url}
            title={ad.campaign_name}
            size="tiny"
          />
        )}
        <p className="m-0 fs-6">
          <strong>{i.t('rm:adDestination')}:</strong>{' '}
          {ad.destination_url || '-'}
        </p>
      </section>
    </article>
  ))
